import React from "react";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { Callout, HTMLSelect, Spinner } from "@blueprintjs/core";

import { MultiBarChart } from "../../Charts/BarChart";

export default class ParkingIncome extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  onByChange() {
    let url = "";
    switch (this.state.by) {
      case "by user type":
        url = "/activity/stmt/income/usertypes?";
        break;
      default:
      case "by park":
        url = "/activity/stmt/income/parks?";
        break;
    }
    this.setState({ loading: true }, () => {
      authenticatedGetFetch(url + this.props.urlsearchparams, (response) => {
        this.setState({
          loading: false,
          data: response["data"],
          labels: response["periods"],
        });
      });
    });
  }

  componentDidMount() {
    if (this.props.urlsearchparams !== undefined)
      this.setState({ loading: true }, () => {
        authenticatedGetFetch(
          "/activity/stmt/income/parks?" + this.props.urlsearchparams,
          (response) => {
            this.setState({
              loading: false,
              data: response["data"],
              labels: response["periods"],
              by: "by park",
            });
          }
        );
      });
  }

  render() {
    if (this.props.urlsearchparams !== undefined)
      return (
        <div>
          <Callout icon="time" title={<Trans>income per parking time</Trans>}>
            {this.state.loading ? (
              <Spinner />
            ) : this.state.data !== undefined && this.state.data.length > 0 ? (
              <div className="flexbox-center">
                <HTMLSelect
                  value={this.state.by}
                  options={[
                    { label: i18n.t("by park"), value: "by park" },
                    { label: i18n.t("by user type"), value: "by user type" },
                  ]}
                  onChange={(s) => {
                    this.setState({ by: s.target.value }, () =>
                      this.onByChange()
                    );
                  }}
                />
                <MultiBarChart
                  datasets={this.state.data}
                  labels={this.state.labels}
                  title={
                    (this.state.by === "by park"
                      ? i18n.t("income per parking time per park")
                      : i18n.t("income per parking time per user type")) +
                    " (€)"
                  }
                  large={true}
                  unitType="amount"
                />
              </div>
            ) : (
              <Callout intent="primary">
                <Trans>no data for the period</Trans>
              </Callout>
            )}
          </Callout>
        </div>
      );
    else return null;
  }
}
